import { useState, useEffect } from 'react';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export const useResponsiveDevice = (): DeviceType => {
    const [device, setDevice] = useState<DeviceType>('desktop');

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setDevice('mobile');
            } else if (window.innerWidth < 1024) {
                setDevice('tablet');
            } else {
                setDevice('desktop');
            }
        };

        // Evaluar en montura
        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return device;
};
